module.exports = __webpack_public_path__ + "img/njggxxcgwlogo.7ae03a1e.png";